const statusClasses = {
  Ativo: "border-emerald-200 bg-emerald-50 text-emerald-700",
  Inativo: "border-slate-200 bg-slate-50 text-slate-600",
  Sucesso: "border-emerald-200 bg-emerald-50 text-emerald-700",
  Falha: "border-red-200 bg-red-50 text-red-700",
  EmExecucao: "border-sky-200 bg-sky-50 text-sky-700",
  Cancelada: "border-amber-200 bg-amber-50 text-amber-700",
  ExpiradoPorTempo: "border-orange-200 bg-orange-50 text-orange-700",
  Administrador: "border-violet-200 bg-violet-50 text-violet-700",
  Usuario: "border-slate-200 bg-slate-50 text-slate-700",
};

const statusLabels = {
  EmExecucao: "Em execucao",
  ExpiradoPorTempo: "Expirado por tempo",
};

export default function StatusBadge({ value, label }) {
  const text = label ?? statusLabels[value] ?? value;
  const className = statusClasses[value] ?? "border-slate-200 bg-slate-50 text-slate-700";

  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${className}`}>
      {text}
    </span>
  );
}
